import React from "react";
import SkillsView from "./view";

const SkillsPage = () => {
  return <SkillsView />;
};

export default SkillsPage;